module.exports = __webpack_public_path__ + "static/media/van.93f73f04.png";